module.exports = __webpack_public_path__ + "img/icon-arrow-right.362ae5b6.svg";